//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { service_detail } from '@/apis/product'
export default {
    data() {
        return {
            id: 0,
            item: {},
            showAllVenues: false
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id > 0) {
            this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await service_detail(this.id);
                this.item = res.data;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleToEdit() {
            this.$router.push(`/product/form/${this.id}`);
        },
        getTypeCodeName(code) {
            switch (code) {
                case 'TENANT':
                    return '租場';
                case 'COURSE':
                    return '課程';
                case 'TEMP':
                    return '臨打';
                case 'ACTIVITY':
                    return '活動';
                case 'MATCH':
                    return '比賽';
                default:
                    return code;
            }
        },
        getArrStrFirst(arrString) {
            if (this.arrString) {
                const res = JSON.parse(arrString);
                return res.length > 0 ? res[0] : null;
            }
        }
    }
}
